// PrivateShowGift.js
import { connect } from 'react-redux';

import {
  EARLYBIRD_DISPLAY_TICKET_DIAMOND,
  SHOW_DISPLAY_TICKET_DIAMOND,
} from '../RemoteConfigKeys.js';
import PrivateShowGift from '../component/PrivateShowGift.jsx';
import fetchGift from '../action/fetchGift.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';
import getPrivateShowTicketAmount from '../selector/getPrivateShowTicketAmount.js';
import getGiftData from '../selector/getGiftData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getListData from '../selector/getListData.js';
import getPrivateShowProductId from '../selector/getPrivateShowProductId.js';
import getIsPrivateShowEarlyBirdTicket from '../selector/getIsPrivateShowEarlyBirdTicket.js';
import getGoalData from '../selector/getGoalData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const mapStateToProps = (state, { streamId, type }) => {
  const meId = getMeData(state, 'id');
  const fundingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'fundingId'
  );
  const performingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'performingId'
  );
  const giftId = getPrivateShowProductId(
    state,
    streamId,
    fundingId,
    performingId
  );
  const mvpUserId = getListData(
    state,
    ['goal', fundingId, 'breakdown'],
    'itemIds'
  )?.[0];
  const status = getPrivateShowStatus(state, streamId);
  const price = getGiftData(state, giftId, 'price');
  const count = +getPrivateShowTicketAmount(
    state,
    streamId,
    fundingId,
    mvpUserId,
    meId,
    type
  );
  const remoteConfigEarlyBirdPrice = getRemoteConfigData(
    state,
    EARLYBIRD_DISPLAY_TICKET_DIAMOND
  );
  const remoteConfigTicketPrice = getRemoteConfigData(
    state,
    SHOW_DISPLAY_TICKET_DIAMOND
  );
  const earlyBirdDiscountPercentage = getGoalData(
    state,
    [fundingId, 'context'],
    'discount_percentage'
  );
  const isAuthed = !!meId;
  const isEarlyBirdTicket = getIsPrivateShowEarlyBirdTicket(
    state,
    giftId,
    fundingId
  );
  const isGiftFetched = getNetworkingData(
    state,
    ['gift', 'item', giftId],
    'isFetched'
  );
  return {
    giftId,
    status,
    remoteConfigEarlyBirdPrice,
    remoteConfigTicketPrice,
    price,
    count,
    earlyBirdDiscountPercentage,
    isAuthed,
    isEarlyBirdTicket,
    isGiftFetched,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchGift: data => dispatch(fetchGift(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateShowGift);
